import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import { PaymentService } from './payment.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [PaymentService]
})
export class PaymentModule {}



// WEBPACK FOOTER //
// ./src/app/modules/payment/payment.module.ts